module.exports = __webpack_public_path__ + "static/media/entry-bg.8f76eb34.png";